<template>
  <div
    class="hrTimesheets-consultant-card non-selectable manager-ts-timesheet-card"
    @click="onManagerTimesheetCardClick"
  >
    <div class="hrTimesheets-card-content">
      <div class="hrTimesheets-main-header manager-ts-hr-card-header">
        <div class="manager-ts-hr-card-header__row">
          <span class="hrTimesheets-main-label">HR Timesheet ID</span>
          <span class="hrTimesheets-status-badge" :class="statusBadgeClass(sheet.status, 'hr')">
            {{ sheet.status }}
          </span>
        </div>
        <div class="manager-ts-hr-card-header__row manager-ts-hr-card-header__row--values">
          <span class="hrTimesheets-main-value manager-ts-hr-card-header__id">{{ sheet.hrTimesheetId || 'N/A' }}</span>
          <span class="hrTimesheets-secondary-value manager-ts-hr-card-header__source">{{
            sheet.timesheetFrom || 'N/A'
          }}</span>
        </div>
      </div>
      <ManagerTimesheetCardDetails :sheet="sheet" />
      <ManagerTimesheetCardAttachments
        :attachments="sheet.attachments"
        list-source="hr"
        @open-stored="(att) => $emit('open-attachment', { attachment: att, sheet })"
      />
    </div>
    <div class="manager-ts-card-actions">
      <button
        type="button"
        class="hrTimesheets-fetch-btn manager-ts-edit-card-btn"
        @click.stop="$emit('edit', sheet)"
      >
        <i class="bi bi-pencil-square"></i>
        <span>Edit</span>
      </button>
    </div>
  </div>
</template>

<script>
import { statusBadgeClass } from '../utils/managerTimesheetCardHelpers';
import ManagerTimesheetCardDetails from './ManagerTimesheetCardDetails.vue';
import ManagerTimesheetCardAttachments from './ManagerTimesheetCardAttachments.vue';
import '@/modules/consultant/styles/HRTimesheets.css';
import '../styles/ManagerTimesheetCardShell.css';

export default {
  name: 'ManagerHRTimesheetCard',
  components: {
    ManagerTimesheetCardDetails,
    ManagerTimesheetCardAttachments
  },
  props: {
    sheet: {
      type: Object,
      required: true
    },
  },
  emits: ['edit', 'open-attachment'],
  methods: {
    statusBadgeClass,
    onManagerTimesheetCardClick(event) {
      const el = event.target;
      if (el.closest('.manager-ts-card-actions')) return;
      if (el.closest('.manager-ts-attachments')) return;
      if (el.closest('button, a')) return;
      this.$emit('edit', this.sheet);
    }
  }
};
</script>
